import { Component, OnInit } from '@angular/core';
import { ShoppingService } from '../../core/services/shopping.service';
import { HelperService } from '../../core/services/helper.service';
import { appVariables, appMessages } from '../../core/constants/Common.constant';
import { Constants } from '../../core/constants/constants';

@Component({
  selector: 'app-promo-code',
  templateUrl: './promo-code.component.html',
  styleUrls: ['./promo-code.component.css']
})
export class PromoCodeComponent implements OnInit {

  PromoCodeDisplay = {'Message' : '', 'class': 'redcolor'};
  PromoCode = '';
  TotalItems = 0;
  promoCodeApplied: boolean = false;
  constructor(private shoppingService: ShoppingService, private helperService: HelperService) { }

  ngOnInit() {
    this.PromoCode=this.helperService.getFromLocalStorage(appVariables.promoCode);
    this.shoppingService.observeCartItems.subscribe(cartItemsList => {
      this.TotalItems = cartItemsList.length;
      this.PromoCodeDisplay = {'Message' : '', 'class': 'redcolor'};
      if (this.PromoCode && this.PromoCode.trim() !== '') {
      this.promoCodeApplied = true;
      } else {
      this.promoCodeApplied = false;
      }
    });
    
  }

  OnPromoCodeRemove(){
    this.promoCodeApplied = false;
    this.PromoCode = '';
    this.shoppingService.GetCartItemsFromAPI(this.PromoCode, this.helperService.getFromLocalStorage(appVariables.cartGUID))
      .subscribe(
        (response) => {
          this.shoppingService.setCartItems(response.Data);
          this.promoCodeApplied=false;
           this.helperService.setToLocalStorage(appVariables.promoCode, this.PromoCode);
          
        }
      ); 
  }

  OnPromoCodeClick(PromoCode: string) {
   this.helperService.setToLocalStorage(appVariables.promoCode, this.PromoCode);
    this.PromoCodeDisplay = {'Message' : '', 'class': 'redcolor'};
    this.shoppingService.GetCartItemsFromAPI(PromoCode, this.helperService.getFromLocalStorage(appVariables.cartGUID))
      .subscribe(
        (response) => {
          if (response.Data && response.Data.length > 0) {
            this.shoppingService.setCartItems(response.Data);
            this.PromoCodeDisplay.Message = response.Data[0]['PromoCodeMessage'];
            if (this.PromoCodeDisplay.Message === appVariables.PromoCodeDisplayMessage) {
             this.helperService.setToLocalStorage(appVariables.promoCode, this.PromoCode);
              this.PromoCodeDisplay.class = 'greencolor';
              this.promoCodeApplied = true;            
            }            else {
             this.helperService.setToLocalStorage(appVariables.promoCode, '');
              this.PromoCodeDisplay.class = 'redcolor';
              this.promoCodeApplied = false;
            }
            this.shoppingService.IsValidPromoCodeApplied.emit(true);
          }
        
        },
        (error) => {
         this.helperService.setToLocalStorage(appVariables.promoCode, '');
          this.PromoCodeDisplay.Message = appMessages.CommonError;
          this.PromoCodeDisplay.class = 'redcolor';
        }
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/shoppingcart/promo-code/promo-code.component.ts